import { useState } from "react";
import {
  Modal,
  Box,
  Tabs,
  Tab
} from "@mui/material";
import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import ForgotPwd from "./ForgotPwd";
import Registration from "./Registration";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../redux/authSlice";
import { toast } from "react-toastify";
import { login } from "../../../../AsianExchangeSrc/api";
import { loginSuccess } from "../../../../AsianExchangeSrc/redux/slices/userSlice";
import { setAccountType } from "../../../../AsianExchangeSrc/redux/slices/accountSlice";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // bgcolor: '#152234',
  boxShadow: 1,
  p: "36px 18px 40px 18px",
  color: "#FFF",
  borderRadius: "20px",
};

export default function Login() {
  const [tabValue, setTabValue] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [openForgotPwd, setOpenForgotPwd] = useState(false);
  const openRegister = useSelector((state) => state.auth.openRegister);
  const openLogin = useSelector((state) => state.auth.openLogin);
  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    userName: "",
    password: "",
    x_panel_type: "user",
  });  

  const handleClose = () => dispatch(updateAuth({ openLogin: false }));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const onClickForgotPwd = () => {
    setOpenForgotPwd(true);
  };

  const handlePasswordVisibility = (e) => {
    e?.preventDefault();
    setShowPassword(!showPassword);
  };

  const onChangeFormDetails = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "phone" ? value.replace(/\D/g, "") : value,
    }));
  };

  const onClickRegister = () => {
    dispatch(updateAuth({ openLogin: false }));
    dispatch(updateAuth({ openRegister: true }));
  };

  const handleLogin = async (e) => {
    e?.preventDefault();
    try {
      const response = await login(formData);

      if (response.data) {
        const { token, userdata } = response.data;

        dispatch(
          loginSuccess({
            userData: userdata,
            loggedInType: "real",
            token: token,
          })
        );

        dispatch(
          setAccountType({
            userData: userdata,
            type: "real",
          })
        );

        if (response.success === true) {
          toast.error(response.data.message);
          setTimeout(() => {
            window.location.href = "/";
          }, 100);
        } else {
          toast.error(response.data.message);
        }
      }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <>
      <Modal open={openLogin} onClose={null}>
        <Box
          sx={style}
          className="bg-[#97a3ba96] w-11/12 md:w-[400px] box-border p-6 rounded-lg shadow-lg text-white"
          style={{ position: "relative" }}
        >
          <div className="register-head">
            <button
              className="absolute z-10 top-2 right-2"
              onClick={handleClose}
            >
              <Close color="#FFF" />
            </button>
            <div className="text-2xl font-bold text-center">Login</div>
          </div>
          <div className="mt-4">
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              centered
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="User ID" />
              <Tab label="Phone" />
            </Tabs>
          </div>
          <form className="mt-6" onSubmit={handleLogin}>
            {/* Conditional rendering for User ID or Phone */}
            {tabValue === 1 ? (
              <>
                <div className="mobile-input mt-6 w-full flex box-border font-semibold rounded-lg bg-[#1c2d4480] text-white">
                  <div className="country-code px-5 bg-[#1c2d4499] py-4 rounded-l-lg">
                    +91
                  </div>
                  <input
                    name="phone"
                    minLength={10}
                    maxLength={10}
                    type="text"
                    placeholder="Phone Number"
                    className="text-base px-5 w-full bg-transparent outline-none py-4"
                    onChange={onChangeFormDetails}
                  />
                </div>
                {formErrors.userName && (
                  <p className="text-red-500 text-sm">{formErrors.userName}</p>
                )}
              </>
            ) : (
              <div className="mb-4 bg-[#1c2d4480] rounded-lg text-white">
                <input
                  name="userName"
                  type="text"
                  placeholder="Username"
                  className="text-base w-full bg-transparent outline-none px-4 py-4"
                  onChange={onChangeFormDetails}
                />
              </div>
            )}

            <div>
              <div className="pwd-input mt-6 w-full flex box-border font-semibold px-5 rounded-lg bg-[#1c2d4480] text-white">
                <input
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="text-base w-full bg-transparent outline-none py-4"
                  onChange={onChangeFormDetails}
                />
                <button onClick={handlePasswordVisibility}>
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </button>
              </div>
              {formErrors.password && (
                <p className="text-red-500 text-sm">{formErrors.password}</p>
              )}
            </div>
            {/* Forgot Password */}
            <div className="mb-4 mt-14 ms-6 flex">
              <span className="me-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke="#152234"
                  fill="#152234"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-circle-help"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path
                    stroke="white"
                    d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                  />
                  <path stroke="white" d="M12 17h.01" />
                </svg>
              </span>
              <div
                onClick={onClickForgotPwd}
                className="text-base font-medium cursor-pointer"
              >
                Forgot Password?
              </div>
            </div>

            {/* Login Button */}
            <div className="mt-8 font-bold">
              <button className="py-4 w-full text-center bg-cnf-btn rounded-lg text-white box-shadow-register text-base registeration-btn-bg">
                Login
              </button>
            </div>
          </form>

          {/* <h2 className="text-center font-bold text-xl mb-4">Login</h2> */}

          {/* Tabs for User ID and Phone */}

          {/* Registration Link */}
          <div className="mt-4 text-center">
            <p className="text-sm">
              <div>Don’t have an account?</div>
              <button
                className="text-[#3dbefd] font-medium"
                onClick={onClickRegister}
              >
                Registration
              </button>
            </p>
          </div>
        </Box>
      </Modal>
      {openForgotPwd && (
        <ForgotPwd open={openForgotPwd} setOpen={setOpenForgotPwd} />
      )}
      {openRegister && <Registration />}
    </>
  );
}
